export { WIDGETS_REGISTRY } from "./widgets.config";
export {
  buildWidgetId,
  buildWidgetInstanceId,
  registerWidget,
} from "./widgets.utils";
